"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@nextui-org/react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
function UseCaseComponent(_a) {
    var title = _a.title, description = _a.description, onChange = _a.onChange, icon = _a.icon, checked = _a.checked;
    var _b = (0, react_1.useState)(checked || false), value = _b[0], setValue = _b[1];
    return ((0, jsx_runtime_1.jsx)(react_2.Card, __assign({ className: "w-full max-w-xl shadow-sm border border-borders p-4" }, { children: (0, jsx_runtime_1.jsx)(react_2.CardBody, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex items-center justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex items-center gap-3" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "bg-blue-100 rounded-full h-10 w-10 p-2" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon }) })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "text-lg font-semibold" }, { children: title })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-sm text-gray-500" }, { children: description }))] })] })), (0, jsx_runtime_1.jsx)(react_2.Switch, { isSelected: value, onValueChange: setValue, onChange: function (e) {
                            onChange(e.target.checked);
                        }, size: "lg", color: "primary", classNames: {
                            wrapper: (0, react_2.cn)("bg-gray-300", value ? "bg-blue-600" : ""),
                            thumb: "bg-white",
                        } })] })) }) })));
}
exports.default = UseCaseComponent;
